import AttachmentsPanel from "../AttachmentsPanel";
import { Card } from "../ui/card";
import { FolderOpen } from "lucide-react";

export default function DocsTab({ project }) {
  return (
    <div className="max-w-3xl space-y-4" data-testid="docs-tab-content">
      <div>
        <h3 className="font-heading font-semibold flex items-center gap-2">
          <FolderOpen className="h-4 w-4 text-primary" /> Project Documentation
        </h3>
        <p className="text-sm text-muted-foreground mt-1">
          Specs, datasheets, reports and reference material for this project. PDFs and images open right in the browser.
        </p>
      </div>
      <Card className="p-5">
        <AttachmentsPanel entityType="project" entityId={project.id} />
      </Card>
    </div>
  );
}
